/**
 * The calendar's tag copy (#680) — what the event editor and the full event
 * page say about tags, in one place.
 *
 * TAG_ORG_WIDE_HINT is the SAME sentence the inbox shows
 * (components/inbox/MailTagPicker.jsx `ORG_WIDE_HINT`): one rule, one wording.
 * It is duplicated rather than imported so the calendar does not depend on an
 * inbox module; lib/__tests__/tagCopy.test.js fails if the two drift.
 */
export const TAG_ORG_WIDE_HINT =
    'Tags are shared across your organisation — a new tag is visible to everyone, including on contacts.';

/** A tag on a Google/Outlook event lives in the CRM only (#682): nothing is written to the provider. */
export const CRM_ONLY_NOTE = "Tags stay in NurtureCRM — they aren't added to Google Calendar or Outlook.";

/** #682 tags a recurring occurrence as its whole series. */
export const SERIES_TAG_NOTE = 'Tags apply to every occurrence in this series.';

// The codes POST /api/oauth/calendar/events/tags and /tags/resolve answer with
// (a 422 `detail.code`, or a `failed[].reason` per event).
const ERROR_TEXT = {
    unknown_tag: 'That tag no longer exists — pick it again',
    tags_required: 'Choose a tag to add or remove',
    tag_name_required: 'Type a tag name',
    tag_too_long: 'That tag name is too long',
    too_many_tags: 'Too many tags at once — 20 at most',
    not_found: 'This event is no longer on your calendar',
    provider_unavailable: "Your calendar provider didn't answer — try again in a moment",
    series_pending: 'This series is still syncing — try tagging it again in a minute',
};

/**
 * A tag failure, in words. Accepts an axios error (422 `detail.code` or a
 * string `detail`) or a bare `failed[].reason`.
 */
export function eventTagErrorText(errOrReason, fallback = "Couldn't save the tags") {
    if (typeof errOrReason === 'string') return ERROR_TEXT[errOrReason] || fallback;
    const detail = errOrReason?.response?.data?.detail;
    if (typeof detail === 'string') return ERROR_TEXT[detail] || detail;
    return ERROR_TEXT[detail?.code] || fallback;
}
